import React from 'react';
import pick from 'lodash/pick';
import {validate} from 'records/CoachingPlan';
import InputField from 'components/pure/utils/form/InputField';
import FieldContainer from 'components/pure/utils/form/FieldContainer';
import './ObjectiveStep.styl';
import moment from 'moment';

export default class ObjectiveStep extends React.PureComponent {
  static title = 'Objective';

  static validate(plan) {
    return pick(validate(plan), ['objective', 'name']);
  }

  componentDidMount() {
    const {model: coachingPlan, completedSteps, step, editMode} = this.props;

    // Don't overwrite objective data when editing
    if (editMode) return;

    // if we already preloaded the objective, don't preload it again!
    if (!completedSteps.has(step)) {
      this.props.onChange(
        coachingPlan
          .set('objective', coachingPlan.getDefaultCoachingPlanObjective())
          .set('name', coachingPlan.getDefaultCoachingPlanShortName(moment()))
      );
    }
  }

  render() {
    const {model: coachingPlan, showErrors} = this.props;
    const errors = ObjectiveStep.validate(coachingPlan);

    return (
      <div className="coaching-step coaching-plan-wizard-objective">
        <p>What do you want to accomplish with this coaching plan?</p>
        <FieldContainer error={showErrors ? errors.objective : null}>
          <InputField
            value={coachingPlan.objective || undefined}
            onChange={value => this.props.onChange(coachingPlan.set('objective', value))}
          />
        </FieldContainer>
        <p className="plan-name-instructions">Give this plan a short name:</p>
        <FieldContainer error={showErrors ? errors.name : null}>
          <InputField
            value={coachingPlan.name || undefined}
            onChange={value => this.props.onChange(coachingPlan.set('name', value))}
          />
        </FieldContainer>
      </div>
    );
  }
}
